<script>
import GenericButtonCta from "./GenericButtonCta.vue";

export default {
    name: "DeviceIntentionPopin",
    components: {GenericButtonCta},
    props: {
        title: {
            type: String,
            required: true
        },
        visual: {
            type: Object,
            required: true
        },
        textSub: {
            type: String,
            required: true
        },
        subsidized: {
            type: Boolean,
            required: true
        },
        text4xCb: {
            type: String,
            required: true
        },
        enable4xCb: {
            type: Boolean,
            required: true
        },
        pageTitle: {
            type: String,
            required: true
        },
        pageType: {
            type: String,
            required: true
        },
        popinModal: {
            type: Object,
            required: true
        },
        popinClassName: {
            type: String,
            required: false,
            default: ""
        },
        withDeviceButtonCta: {
            type: Object,
            required: false,
            default: undefined
        },
        withoutDeviceButtonCta: {
            type: Object,
            required: false,
            default: undefined
        }
    },
    mounted() {
        $('#' + this.popinModal.id).on('show.bs.modal', function (e) {
            $('.modal.show').not(e.target).modal('hide');
        });
    }
}
</script>

<template>
    <!--/* POPIN DEVICE INTENTION*/-->
    <ob1-popin-modal-visual
        :id="popinModal.id"
        :aria-labelledby="popinModal.label"
        :show-close-button="popinModal.showCloseButton"
        :class="popinClassName"
    >
        <template #visual>
            <div class="ob1-modal-img">
                <div class="image-crop">
                    <img :src="visual.src" :alt="visual.alt">
                </div>
            </div>
        </template>

        <template #content>
            <section
                :data-titre-page="pageTitle"
                :data-type-page="pageType"
            >
                <h4>{{ title }}</h4>
                <div v-if="subsidized" class="alert-container alert-container-sm additional-message">
                    <p class="alert">
                        <span class="alert-icon icon-phone-fund-euro" aria-hidden="true" />
                        <span class="ob1-alert-title">{{ textSub }}</span>
                    </p>
                </div>
                <div v-if="!subsidized && enable4xCb" class="alert-container alert-container-sm additional-message">
                    <p class="alert">
                        <span class="alert-icon icon-four-x-credit-card" aria-hidden="true" />
                        <span class="ob1-alert-title">{{ text4xCb }}</span>
                    </p>
                </div>
                <div class="ob1-modal-footer-visual">
                    <div class="row d-flex align-items-end">
                        <div class="order-1 order-md-2 col-12 col-md-6 px-0">
                            <generic-button-cta
                                v-if="withDeviceButtonCta"
                                :dto-from-object="withDeviceButtonCta"
                            />
                        </div>
                        <div class="order-2 order-md-1 col-12 col-md-6 pt-2">
                            <generic-button-cta
                                v-if="withoutDeviceButtonCta"
                                :dto-from-object="withoutDeviceButtonCta"
                                :css-classes="'ob1-link pb-0'"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </ob1-popin-modal-visual>
</template>

<style scoped lang="scss">

@media (min-width: 736px) {
    .image-crop {
        width: 405px;
        overflow: hidden;
        position: relative;
    }

    .image-crop img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
